import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useXtdhTokenContributorsQuery } from "@/hooks/useXtdhTokenContributorsQuery";
import { CollectionLoadMore } from "../subcomponents/CollectionLoadMore";
import { useXtdhTokenContributorsFilters } from "./hooks/useXtdhTokenContributorsFilters";
import { XtdhTokenContributorsControls } from "./subcomponents/XtdhTokenContributorsControls";
import { XtdhTokenContributorsList } from "./subcomponents/XtdhTokenContributorsList";
import { XtdhGrantDetailsPanel } from "./subcomponents/XtdhGrantDetailsPanel";
interface XtdhTokenContributorsPanelProps {
  readonly contract: string;
  readonly tokenId: number | null;
  readonly selectedGrantId: string | null;
  readonly onSelectGrant: (grantId: string, label: string) => void;
}
const CONTRIBUTORS_PAGE_SIZE = 25;
export function XtdhTokenContributorsPanel(t0) {
  const $ = _c(38);
  const {
    contract,
    tokenId,
    selectedGrantId,
    onSelectGrant
  } = t0;
  const {
    activeSortField,
    activeSortDirection,
    activeGroupBy,
    apiOrder,
    handleSortChange,
    handleGroupByChange
  } = useXtdhTokenContributorsFilters();
  let t1;
  if ($[0] !== activeGroupBy || $[1] !== activeSortField || $[2] !== apiOrder || $[3] !== contract || $[4] !== tokenId) {
    t1 = {
      contract,
      tokenId,
      pageSize: CONTRIBUTORS_PAGE_SIZE,
      sortField: activeSortField,
      order: apiOrder,
      groupBy: activeGroupBy
    };
    $[0] = activeGroupBy;
    $[1] = activeSortField;
    $[2] = apiOrder;
    $[3] = contract;
    $[4] = tokenId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    contributors,
    isLoading,
    isError,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    refetch,
    fetchNextPage,
    errorMessage,
    isEnabled
  } = useXtdhTokenContributorsQuery(t1);
  let t2;
  if ($[6] !== refetch) {
    t2 = () => {
      refetch().catch(_temp);
    };
    $[6] = refetch;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleRetry = t2;
  let t3;
  if ($[8] !== fetchNextPage || $[9] !== hasNextPage || $[10] !== isFetchingNextPage) {
    t3 = () => {
      if (!hasNextPage || isFetchingNextPage) {
        return;
      }
      fetchNextPage().catch(_temp2);
    };
    $[8] = fetchNextPage;
    $[9] = hasNextPage;
    $[10] = isFetchingNextPage;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleLoadMore = t3;
  const controlsDisabled = isLoading || isFetching;
  const showLoadMore = hasNextPage && isEnabled;
  if (selectedGrantId) {
    let t4;
    if ($[12] !== selectedGrantId) {
      t4 = <XtdhGrantDetailsPanel grantId={selectedGrantId} />;
      $[12] = selectedGrantId;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    return t4;
  }
  let t4;
  if ($[14] !== activeGroupBy || $[15] !== activeSortDirection || $[16] !== activeSortField || $[17] !== controlsDisabled || $[18] !== handleGroupByChange || $[19] !== handleSortChange) {
    t4 = <XtdhTokenContributorsControls activeSortField={activeSortField} activeSortDirection={activeSortDirection} activeGroupBy={activeGroupBy} onSortChange={handleSortChange} onGroupByChange={handleGroupByChange} isDisabled={controlsDisabled} />;
    $[14] = activeGroupBy;
    $[15] = activeSortDirection;
    $[16] = activeSortField;
    $[17] = controlsDisabled;
    $[18] = handleGroupByChange;
    $[19] = handleSortChange;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== activeGroupBy || $[22] !== contributors || $[23] !== errorMessage || $[24] !== handleRetry || $[25] !== isEnabled || $[26] !== isError || $[27] !== isLoading || $[28] !== onSelectGrant) {
    t5 = <XtdhTokenContributorsList contributors={contributors} groupBy={activeGroupBy} isEnabled={isEnabled} isLoading={isLoading} isError={isError} errorMessage={errorMessage} onRetry={handleRetry} onSelectGrant={onSelectGrant} />;
    $[21] = activeGroupBy;
    $[22] = contributors;
    $[23] = errorMessage;
    $[24] = handleRetry;
    $[25] = isEnabled;
    $[26] = isError;
    $[27] = isLoading;
    $[28] = onSelectGrant;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[30] !== handleLoadMore || $[31] !== isFetchingNextPage || $[32] !== showLoadMore) {
    t6 = <CollectionLoadMore isVisible={showLoadMore} isFetching={isFetchingNextPage} onLoadMore={handleLoadMore} />;
    $[30] = handleLoadMore;
    $[31] = isFetchingNextPage;
    $[32] = showLoadMore;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  let t7;
  if ($[34] !== t4 || $[35] !== t5 || $[36] !== t6) {
    t7 = <section className="tw-space-y-4">{t4}{t5}{t6}</section>;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
  } else {
    t7 = $[37];
  }
  return t7;
}
function _temp2() {}
function _temp() {}